import { Component, OnInit, ViewChild } from "@angular/core";
import { HeaderService } from "src/app/_services/header.service";
import { UserService } from "../../_services";
import { ThisPlatform } from "../../_services/platform.service";
import { RowsLoaderService } from "../../_services/rows-loader.service";
import { PaginationClientSideOptions } from "../_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "../_component/pagination-client-side/pagination-column.class";
import { CompanyViewComponent } from "./company-view/company-view.component";
import { Company } from "./company.model";
import { CompanyService } from "./company.service";

@Component({
  selector: "app-company",
  templateUrl: "./company.page.html",
  styleUrls: ["./company.page.scss"],
})
export class CompanyPage implements OnInit {
  constructor(
    private companyServ: CompanyService,
    private userServ: UserService,
    public p: ThisPlatform,
    private headerServ: HeaderService,
  ) {}

  companies: Company[];
  companiesFilter: Company[];
  companyAddRole: boolean;
  showLoader: boolean = false;

  componentRef: any = CompanyViewComponent;
  columnsDefinition: PaginationColumn[] = [
    { name: "image", displayName: "Logo", size: 2, sortable: false },
    {
      name: "name",
      displayName: "COMPANY.NAME",
      size: 4,
      sortable: true,
      colValue: (row) => {
        return row.name;
      },
    },
    {
      name: "description",
      displayName: "COMPANY.DESCRIPTION",
      size: 6,
      sortable: true,
      sortableMobile: false,
    },
  ];

  rowsLoader: RowsLoaderService;

  @ViewChild("searchBar")
  searchBar;

  async ngOnInit() {
    this.companyAddRole = await this.userServ.hasRolesAsync(["company.add"]);
  }

  rowsLoaderInit() {
    this.showLoader = false;
    if (this.rowsLoader) {
      if (this.searchBar.ngModel) {
        this.companiesFilter = this.companies.filter((s) =>
        (this.p.renderMobile ? s.name : ( s.name + " " + s.description) )
        .toUpperCase()
        .includes(this.searchBar.ngModel.toUpperCase())
        );
      } else {
        this.companiesFilter = this.companies;
      }
      this.rowsLoader.init(this.companiesFilter);
    }
  }
  
  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    headerStickyPosition: 58,
    addButtonText: "ADD_COMPANY.ADD_COMPANY",
    noResultsAddLink: "./app/company/add",
    permissionAdd: "company.add"
  };
  
  ionViewWillEnter() {
    this.headerServ.setHeaderInit({
      title: "COMPANIES",
    });
    this.loadCompanies();
  }
  
  loadCompanies() {
    this.showLoader = true;
  
    this.companyServ.GetAll().subscribe((res: Company[]) => {
      this.companyServ.companies = res;
      this.companies = this.companiesFilter = res;
      this.rowsLoaderInit();
    });
  }

  onChangeSearch() {
    this.rowsLoaderInit();
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }
}
